import { useEffect, useState } from "react";

const links = [
  { id: "work", label: "Work" },
  { id: "approach", label: "Process" },
];

export default function Nav({ onNav }) {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 8);
      const manifesto = document.querySelector('.manifesto-section');
      const manifestoTop = manifesto ? manifesto.getBoundingClientRect().top + window.scrollY : Number.POSITIVE_INFINITY;
      const shouldUseHeroDark = window.scrollY >= 8 && window.scrollY < manifestoTop - 140;
      const shouldUsePreManifestoDark = window.scrollY >= manifestoTop - 180 && window.scrollY < manifestoTop;
      document.body.classList.toggle('hero-nav-dark', shouldUseHeroDark);
      document.body.classList.toggle('pre-manifesto-nav-dark', shouldUsePreManifestoDark);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => {
      document.body.classList.remove('hero-nav-dark');
      document.body.classList.remove('pre-manifesto-nav-dark');
      document.body.classList.remove('manifesto-nav-dark');
      window.removeEventListener("scroll", onScroll);
    };
  }, []);

  const textColor = scrolled ? "var(--ink)" : "#F4EFE4";

  return (
    <header
      data-testid="site-nav"
      className="fixed top-0 left-0 right-0 z-50"
      style={{
        backdropFilter: scrolled ? "saturate(140%) blur(10px)" : "none",
        background: scrolled ? "rgba(244,239,228,0.78)" : "transparent",
        borderBottom: scrolled ? "1px solid var(--rule)" : "1px solid transparent",
        transition: "background 300ms ease, border-color 300ms ease",
      }}
    >
      <div className="mx-auto flex items-center justify-between nav-row"
           style={{ maxWidth: 1440, padding: "22px 40px" }}>
        <button
          data-testid="logo-home"
          onClick={() => onNav("top")}
          className="font-serif nav-logo"
          style={{
            fontSize: 28,
            letterSpacing: "-0.015em",
            background: "none",
            border: "none",
            color: textColor,
            cursor: "pointer",
            padding: 0,
            fontWeight: 500,
            transition: "color 300ms ease",
          }}
        >
          The Cutdown Club
        </button>

        <nav className="flex items-center" style={{ gap: 28 }}>
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-link-${l.id}`}
              onClick={() => onNav(l.id)}
              className="inkline font-mono nav-mobile-hide"
              style={{
                fontSize: 12,
                letterSpacing: "0.08em",
                textTransform: "uppercase",
                background: "none",
                border: "none",
                cursor: "pointer",
                padding: 0,
                color: textColor,
                transition: "color 300ms ease",
              }}
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="nav-link-contact"
            onClick={() => onNav("contact")}
            className="tcc-nav-cta font-mono"
            style={{ color: textColor, background: "none", cursor: "pointer" }}
          >
            <span className="tcc-nav-dot" aria-hidden="true" />
            <span className="tcc-nav-cta-text">
              <span className="tcc-nav-cta-row1">BOOKING Q3</span>
              <span className="tcc-nav-cta-sep" aria-hidden="true"> — </span>
              <span className="tcc-nav-cta-row2">START A PILOT</span>
            </span>
          </button>
        </nav>
      </div>
    </header>
  );
}
